<template>
  <div class="container-fluid bg-light">
    <div class="row justify-content-center align-items-center min-vh-100">
      <div class="col">
        <div class="card shadow">
          <img src="@/assets/images/logo-wide-black.png" class="card-img-top pt-4 px-4" />
          <div class="card-body">
            <h4 class="card-title text-center">Reset Password</h4>
            <p class="text-center text-muted">
              Enter your new password to reset your password.
            </p>
            <ErrorSummary :error="error" />
            <form ref="form" class="needs-validation" :class="formWasValidated ? 'was-validated' : ''" novalidate @submit.prevent>
              <div class="form-group">
                <label for="newPassword">New Password</label>
                <input
                  v-model="newPassword"
                  type="password"
                  class="form-control"
                  id="newPassword"
                  placeholder="New Password"
                  pattern=".{12,}"
                  required
                  :disabled="isWorking"
                  @keyup.enter="submit"
                />
                <div class="invalid-feedback">Please provide your new password. (minimum 12 characters)</div>
              </div>
              <button type="button" class="btn btn-primary btn-block" @click="submit" :disabled="isWorking" @keyup.enter="submit">
                <span v-if="isWorking" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Reset Password and Sign In
              </button>
            </form>
          </div>
          <div class="card-footer text-center">
            <small class="text-muted">
              Already know your password?
              <router-link to="/signin" v-slot="{ href, navigate }">
                <a :href="href" @click="navigate">Sign In</a>
              </router-link>
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ErrorSummary from "@/components/ErrorSummary.vue";

export default {
  components: {
    ErrorSummary,
  },
  data() {
    return {
      isWorking: false,
      formWasValidated: false,
      error: null,

      newPassword: null,
    };
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
  methods: {
    ...mapActions("cognito", ["signIn"]),
    reset() {
      this.isWorking = false;
      this.formWasValidated = false;
    },
    submit() {
      const payload = {
        userId: this.user.id,
        newPassword: this.newPassword,
      };

      // reset
      this.reset();

      // validations
      if (!this.$refs.form.checkValidity()) {
        this.formWasValidated = true;
        return;
      }

      // api
      this.isWorking = true;
      this.$axios
        .post(`/v1/signin/reset-password`, payload)
        .then(() =>
          this.signIn({
            username: this.user.emailAddress,
            password: payload.newPassword,
          })
        )
        .then(() => this.$router.push("/"))
        .catch(err => (this.error = err))
        .finally(() => (this.isWorking = false));
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  width: 400px;
  margin: 0 auto;
}
</style>
